import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useTheme} from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {
   TableHead,
  Typography,
} from '@mui/material';
import '../components/scrollBar.css';
import '../components/createAudit.css';

function TablePaginationActions (props) {
  const theme = useTheme ();
  const {count, page, rowsPerPage, onPageChange} = props;

  const handleFirstPageButtonClick = event => {
    onPageChange (event, 0);
  };

  const handleBackButtonClick = event => {
    onPageChange (event, page - 1);
  };

  const handleNextButtonClick = event => {
    onPageChange (event, page + 1);
  };

  const handleLastPageButtonClick = event => {
    onPageChange (event, Math.max (0, Math.ceil (count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{flexShrink: 0, ml: 2.5}}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl'
          ? <KeyboardArrowRight />
          : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil (count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl'
          ? <KeyboardArrowLeft />
          : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil (count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default function CustomPaginationActionsTable({data}) {
  const [page, setPage] = React.useState (0);
  console.log(data,"120")
  const keys = Object.keys (data && data[0]);
  console.log(keys);
  
  const updated_keys = [...keys, 'Audit Link', 'Inspection Report'].filter((key)=>key!=="audit_mode");
  console.log (updated_keys, '127');
  const [rowsPerPage, setRowsPerPage] = React.useState (4);

  const emptyRows = page > 0
    ? Math.max (0, (1 + page) * rowsPerPage - (data.length || 0))
    : 0;

  const handleChangePage = (event, newPage) => {
    setPage (newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage (parseInt (event.target.value, 10));
    setPage (0);
  };
  const dispatch = useDispatch ();

  const navigate = useNavigate ();

  const [fontSize, setFontSize] = useState ('0.9rem');
  const [iconWidth, setIconWidth] = useState ('');
  const [padding, setPadding] = useState ('0.2rem');
  const [lineHeight, setLineHeight] = useState ('1.2');

  const [loadingMargin, setLoadingMargin] = useState ('3rem');

  useEffect (() => {
    const handleResize = () => {
      if (window.innerWidth <= 830) {
        setFontSize ('0.7rem');
      } else {
        setFontSize ('0.9rem');
      }
      if (window.innerWidth <= 550) {
        setLoadingMargin ('2rem');
      }
      if (window.innerWidth <= 400) {
        setIconWidth ('1.7rem');
        setPadding ('0.7rem');
        setLineHeight ('0.5');
      } else {
        setIconWidth ('');
        setPadding ('0.7rem');
      }
    };

    handleResize ();

    window.addEventListener ('resize', handleResize);

    return () => {
      window.removeEventListener ('resize', handleResize);
    };
  }, []);

  const link_to_pdf = audit => {
    const hostname = window.location.hostname;
    const port = window.location.port;
    const baseURL = `https://${hostname}:${port}`;
    const url = `${baseURL}/auditInfo/${audit}`;
    return url;
  };

  const link_to_audit = (audit,item) => {
    console.log(item?.audit_mode,187);
    const hostname = window.location.hostname;
    const port = window.location.port;
    const baseURL = `https://${hostname}:${port}`;
    let url;
    if(item?.audit_mode ==="video"){
      url = `${baseURL}/audit/video/permission/${audit}`;
     
    }
    else
    {
      url = `${baseURL}/audit/photo/permission/${audit}`;
    }   
    return url;
  };
  return (
    <div style={{height: '80svh'}}>
      <div
        style={{
          position: 'fixed',
          top: 0,
          width: '100%',
          zIndex: 1000,
        }}
      />
      <div className="main-div">
        <div className="scroll-table">
          <Paper
            elevation={1}
            style={{
              width: '80%',
              borderRadius: '4px',
              overflow: 'hidden',
              marginLeft: '160px',
            }}
          >
            {data && data.length > 0
              ? <TableContainer
                  component={Paper}
                  sx={{
                    padding: '0rem 0.2rem',
                    borderRadius: '4px',
                    maxHeight: 500,
                    overflow: 'auto',
                  }}
                  className="table-cont-scroll"
                >
                  <Table
                    sx={{minWidth: 700}}
                    stickyHeader
                    aria-label="sticky table"
                  >
                    <TableHead>
                      <TableRow style={{borderRadius: '5px'}}>
                        {updated_keys.map ((key, index) => (
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              position: 'sticky',
                              top: 0,
                              zIndex: 1,
                              padding: padding,
                              backgroundColor: '#FF0066',
                              color: 'white',
                              fontWeight: '500',
                              textAlign: 'center',
                              fontSize: fontSize,
                              borderTopLeftRadius: index === 0 ? '4px' : 0, // Add border radius to the first cell
                              borderBottomLeftRadius: index === 0 ? '4px' : 0, // Add border radius to the first cell
                              borderTopRightRadius: index ===
                                updated_keys.length - 1
                                ? '4px'
                                : 0, // Add border radius to the last cell
                              borderBottomRightRadius: index ===
                                updated_keys.length - 1
                                ? '4px'
                                : 0, // Add border radius to the last cell
                              textTransform: 'capitalize',
                              width: index === 0 && '8vw',
                              borderRight: index < updated_keys.length - 1
                                ? '1px solid #fff'
                                : 'none',
                            }}
                            className="table-head"
                            key={key}
                          >
                            {key}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(rowsPerPage > 0
                        ? data.slice (
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                        : data).map ((item, index) => (
                        <TableRow key={index}>
                          {updated_keys.map (key => (
                            <TableCell
                              key={key}
                              style={{
                                textAlign: 'center',
                                padding: '1rem 0.3rem',
                                fontSize: '0.7rem',
                                fontWeight: '600',
                                textTransform: key === 'Inspection Report' || key === 'Audit Link' ?  '':'capitalize',
                                lineHeight: lineHeight,
                              }}
                            >
                              {key === 'used'
                                ? item[key] === 'accessed'
                                    ? <p
                                        style={{
                                          color: 'brown',
                                          fontWeight: '700',
                                        }}
                                      >
                                        created
                                      </p>
                                    : item[key] === 'created'
                                        ? <p
                                            style={{
                                              color: 'brown',
                                              fontWeight: '700',
                                            }}
                                          >
                                            {item[key]}
                                          </p>
                                        : item[key] === 'expired'
                                            ? <p
                                                style={{
                                                  color: '#dc3545',
                                                  fontWeight: '700',
                                                }}
                                              >
                                                {item[key]}
                                              </p>
                                            : item[key] === 'processing'
                                                ? <p
                                                    style={{
                                                      color: '#4682B4',
                                                      fontWeight: '700',
                                                    }}
                                                  >
                                                    {item[key]}
                                                  </p>
                                                : item[key] === 'processed'
                                                    ? <p
                                                        style={{
                                                          color: '#28a745',
                                                          fontWeight: '700',
                                                        }}
                                                      >
                                                        {item[key]}
                                                      </p>
                                                    : <p>{item[key]}</p>
                                : key === 'Inspection Report'
                                    ? item.used === 'processed'
                                        ? <a
                                            href={link_to_pdf (item.audit)}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                              color: '#2d55a3',
                                              textDecoration: 'none',
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                              whiteSpace: 'nowrap',
                                              display: 'inline-block',
                                              maxWidth: '150px',
                                              verticalAlign: 'middle',
                                              padding: '2px',
                                            }}
                                            title={link_to_pdf (item.audit)}
                                          >
                                            {link_to_pdf (item.audit)}
                                          </a>
                                        : 'Audit not used'
                                    : key === 'Audit Link'
                                        ? <a
                                            href={link_to_audit (item.audit,item

                                            )}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                              color: '#2d55a3',
                                              textDecoration: 'none',
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                              whiteSpace: 'nowrap',
                                              display: 'inline-block',
                                              maxWidth: '150px',
                                              verticalAlign: 'middle',
                                              padding: '2px',
                                            }}
                                            title={link_to_audit (item.audit,item)}
                                          >
                                            {link_to_audit (item.audit,item)}
                                          </a>
                                        : item[key]}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                      {emptyRows > 0 &&
                        <TableRow style={{height: 53 * emptyRows}}>
                          <TableCell colSpan={6} />
                        </TableRow>}
                    </TableBody>
                    <TableFooter>
                      <TableRow>
                        <TablePagination
                          rowsPerPageOptions={[
                            4,
                            8,
                            24,
                            {label: 'All', value: -1},
                          ]}
                          colSpan={updated_keys.length || 0}
                          count={data.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          SelectProps={{
                            inputProps: {'aria-label': 'Audits per page'},
                            style: {
                              minWidth: '60px',
                              backgroundColor: '#f0f0f0',
                            },
                          }}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          ActionsComponent={TablePaginationActions}
                          labelRowsPerPage="audits per page"
                        />
                      </TableRow>
                    </TableFooter>
                  </Table>
                </TableContainer>
              : <Typography
                  style={{
                    fontSize: '0.9rem',
                    textAlign: 'center',
                    margin: '1rem',
                  }}
                >
                  No data
                </Typography>}
          </Paper>
        </div>
      </div>
    </div>
  );
}
